import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteInstalledProductByIdMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
}>;


export type DeleteInstalledProductByIdMutation = { __typename?: 'mutation_root', delete_installed_products_by_pk?: { __typename?: 'installed_products', id: any } | null };


export const DeleteInstalledProductByIdDocument = gql`
    mutation deleteInstalledProductById($id: uuid!) {
  delete_installed_products_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteInstalledProductByIdMutationFn = Apollo.MutationFunction<DeleteInstalledProductByIdMutation, DeleteInstalledProductByIdMutationVariables>;

/**
 * __useDeleteInstalledProductByIdMutation__
 *
 * To run a mutation, you first call `useDeleteInstalledProductByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInstalledProductByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInstalledProductByIdMutation, { data, loading, error }] = useDeleteInstalledProductByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInstalledProductByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInstalledProductByIdMutation, DeleteInstalledProductByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInstalledProductByIdMutation, DeleteInstalledProductByIdMutationVariables>(DeleteInstalledProductByIdDocument, options);
      }
export type DeleteInstalledProductByIdMutationHookResult = ReturnType<typeof useDeleteInstalledProductByIdMutation>;
export type DeleteInstalledProductByIdMutationResult = Apollo.MutationResult<DeleteInstalledProductByIdMutation>;
export type DeleteInstalledProductByIdMutationOptions = Apollo.BaseMutationOptions<DeleteInstalledProductByIdMutation, DeleteInstalledProductByIdMutationVariables>;